<template>
  <div>
    <div class="font-weight-bolder mb-3">Einnahme / Ausgabe erfassen</div>
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="input-group">
          <label for="typeInput" class="col-4">Transaktionsart</label>
          <div class="col-8" id="typeInput">
            <input id="radioDeposit"
                   class="ml-2 form-check-inline"
                   type="radio"
                   v-model="editedPayment.type"
                   :disabled="readOnly"
                   value="Deposit"/>
            <label for="radioDeposit">Einnahme</label>
            <input id="radioWithdrawal"
                   class="ml-2 form-check-inline"
                   type="radio"
                   :disabled="readOnly"
                   v-model="editedPayment.type"
                   value="Withdrawal"/>
            <label for="radioWithdrawal">Ausgabe</label>
          </div>
        </div>
        <div class="input-group">
          <label for="transactionDateInput" class="col-4">Rechnungsdatum</label>
          <input id="transactionDateInput"
                 type="date"
                 class="form-control col-8"
                 :disabled="readOnly"
                 v-model="editedPayment.transactionDate"
                 autofocus/>
        </div>
        <div class="input-group">
          <label for="descriptionInput" class="col-4">Beschreibung</label>
          <input id="descriptionInput"
                 class="form-control col-8"
                 :disabled="readOnly"
                 v-model="editedPayment.description"
                 autofocus/>
        </div>
        <div class="input-group">
          <label for="amountInput" class="col-4">Betrag</label>
          <input id="amountInput"
                 type="number"
                 step="0.01"
                 :disabled="readOnly"
                 class="form-control col-4"
                 v-model="editedPayment.amount"
                 @input="amountChanged"/>
          <span class="ml-2">€</span>
        </div>
        <div class="input-group">
          <label for="vatInput" class="col-4">MwSt.</label>
          <input id="vatInput"
                 type="number"
                 step="0.01"
                 class="form-control col-4"
                 :disabled="readOnly"
                 v-model="editedPayment.vat"/>
          <span class="ml-2">€</span>
        </div>
        <div class="input-group">
          <label for="accountInput" class="col-4">Konto</label>
          <select id="accountInput"
                  type="number"
                  step="0.01"
                  class="form-control col-4"
                  :disabled="readOnly"
                  v-model="editedPayment.account">
            <option v-for="account in accounts"
                    :key="account.id"
                    :value="account">
              {{ account.name }}
            </option>
          </select>
        </div>
        <div class="text-right">
          <button v-if="!editedPayment.id"
                  class="btn btn-primary"
                  @click="submit">
            Speichern
          </button>
          <button v-else
                  class="btn btn-danger"
                  @click="deletePayment">
            Löschen
          </button>
        </div>
      </div>
      <div v-if="this.editedPayment.receiptNumber"
           class="col-12 col-md-4 mt-3 mt-md-0">
        <div class="text-center border border-primary">
          <div class="font-weight-bolder">Bon-Nummer</div>
          <div class="receipt-number">#{{ editedPayment.id }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DateTime} from "luxon";

export default {
  data() {
    return {
      readOnly: false,
      accounts: [],
      editedPayment: {
        description: '',
        type: 'Withdrawal',
        amount: 0.00,
        vat: 0.00,
        receiptNumber: 0,
        account: null,
        transactionDate: DateTime.fromJSDate(new Date()).toISODate()
      }
    }
  },
  methods: {
    amountChanged() {
      this.editedPayment.vat = (this.editedPayment.amount * 0.19).toFixed(2)
    },
    submit() {
      this.$api.post('/accounting/transactions', this.editedPayment).then(response => {
        this.readOnly = true
        this.editedPayment = response.data
        this.$emit('update')
      }).catch(error => this.handleError(error))
    },
    deletePayment() {
      this.$api.delete(`/accounting/transactions/${this.editedPayment.id}`).then(() => {
        this.showInfo('Zahlung wurde gelöscht.')
        this.$emit('update')
      })
    }
  },
  mounted() {
    this.$api.get('/accounting/accounts').then(response => {
      this.accounts = response.data
    }).catch(error => this.handleError(error))
  }
}
</script>

<style>
.receipt-number {
  font-weight: bold;
  font-size: larger;
}

.input-group {
  margin-bottom: 1em;
}

label {
  text-align: right;
}
</style>

